/* Under 1000px the app is one column with MainHeader on top, as before. */
.shell {
  min-height: 100vh;
}

/* main fills the height, so the footer after it stands at the bottom of the window on short pages. */
.column {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 0;
}

.content {
  display: block;
  flex: 1;
}

/* Sidebar: petrol gradient, a soft teal glow on top and the journey line faintly at the bottom. */
.sidebar {
  background:
    radial-gradient(120% 40% at 30% 0%, rgba(42, 102, 128, 0.55), transparent 70%),
    linear-gradient(180deg, var(--color-primary-light), var(--color-primary) 55%, var(--color-primary-deep));
  box-sizing: border-box;
  color: var(--color-text-on-primary);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
  height: 100vh;
  overflow-y: auto;
  padding: var(--spacing-l) var(--spacing-m);
  position: sticky;
  top: 0;
}

/* The menu lies over the faint band at the bottom. */
.sidebar > :not([aria-hidden]) {
  position: relative;
  z-index: 1;
}

/* Only the blurred layer, faint, at the bottom of the menu. No tail and no soft field. */
.sidebarBand {
  bottom: 0;
  height: 160px;
  left: 0;
  opacity: 0.35;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.sidebarLogo {
  display: inline-block;
  line-height: 0;
}

.sidebarNav {
  flex: 1;
}

.navHeading {
  color: rgba(255, 255, 255, 0.65);
  font-size: var(--font-size-small);
  font-weight: 700;
  letter-spacing: 0.06em;
  margin: var(--spacing-m) 0 var(--spacing-s);
  text-transform: uppercase;
}

.navHeading:first-child {
  margin-top: 0;
}

.navList {
  display: flex;
  flex-direction: column;
  gap: 2px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navItem,
.profileLink {
  align-items: center;
  border-radius: 10px;
  color: var(--color-text-on-primary);
  display: flex;
  font-size: 1rem;
  gap: var(--spacing-s);
  padding: 0.55rem 0.75rem;
  text-decoration: none;
}

.navItem:hover,
.profileLink:hover {
  background: rgba(255, 255, 255, 0.08);
  text-decoration: none;
}

.navItem:focus-visible,
.profileLink:focus-visible,
.sidebarLogo:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.navItemActive,
.navItemActive:hover {
  background: rgba(255, 255, 255, 0.16);
}

.navIcon {
  display: inline-flex;
  flex-shrink: 0;
}

.navIcon svg {
  fill: currentColor;
}

.sidebarFooter {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
  padding-top: var(--spacing-m);
}

.subscription {
  color: rgba(255, 255, 255, 0.75);
  font-size: var(--font-size-small);
  margin: 0;
  padding: 0 0.75rem;
}

.profileName,
.profileMeta {
  display: block;
}

.profileMeta {
  color: rgba(255, 255, 255, 0.65);
  font-size: var(--font-size-small);
}

/* Top bar: notifications, create survey and the profile menu. */
.topBar {
  align-items: center;
  display: flex;
  gap: var(--spacing-m);
  justify-content: flex-end;
  padding: var(--spacing-m) 40px 0;
  /* The organization name in HamburgerMenu is written for a petrol header. */
  --color-text-on-primary: var(--color-text);
}

.bell {
  align-items: center;
  border-radius: 50%;
  color: var(--color-primary);
  display: inline-flex;
  height: 44px;
  justify-content: center;
  position: relative;
  width: 44px;
}

.bell:hover {
  background: var(--color-tertiary-background);
}

.bellDot {
  background: var(--color-cta);
  border: 2px solid var(--color-background);
  border-radius: 50%;
  height: 10px;
  position: absolute;
  right: 9px;
  top: 9px;
  width: 10px;
}

.createButton {
  background: var(--color-primary);
  border-radius: 999px;
  color: #fff;
  font-size: 1rem;
  font-weight: 400;
  padding: 0.65rem 1.25rem;
  text-decoration: none;
  white-space: nowrap;
}

.createButton:hover {
  background: var(--color-primary-light);
  text-decoration: none;
}

.bell:focus-visible,
.createButton:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* From 1000px: fixed sidebar and a 12-column grid with 40px air. */
@media (min-width: 1000px) {
  .shell {
    display: grid;
    grid-template-columns: 260px minmax(0, 1fr);
  }

  .content {
    --container: 100%;
    padding: 0 40px 40px;
  }

  .grid {
    column-gap: 24px;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    padding-top: var(--section-margin);
    row-gap: var(--section-margin);
  }

  /* Children span all 12 columns unless they ask for less (Section span). */
  :where(.grid) > * {
    grid-column: 1 / -1;
  }

  /* Margins don't collapse in a grid, so the row gap does the spacing instead. */
  .content .grid > * {
    margin-bottom: 0;
    margin-top: 0;
  }
}
